export default __webpack_public_path__ + "b80d55b4dfe9e194b1dad4e1f71be480.webp";